import { useMemo } from 'react';
import { SkeletonLoader, DateCell, DateCellAction } from '@equip.health/ui';
import { toUTCMidnight, toLocalMidnight } from '~/lib/util/date.util';

interface InquiryTargetAdmissionDateCellProps {
  handleChange: (date: Date, inquiryId: string, version: string) => void;
  id: string;
  inquiryId: string;
  targetAdmissionDate: string;
  version: string;
}

const InquiryTargetAdmissionDateCell = ({
  handleChange,
  id,
  inquiryId,
  targetAdmissionDate,
  version,
}: InquiryTargetAdmissionDateCellProps) => {
  const dateValue: Date | null = useMemo(() => {
    return targetAdmissionDate ? new Date(targetAdmissionDate) : null;
  }, [targetAdmissionDate]);

  const handleChangeDate = ({ date }) => {
    handleChange(toUTCMidnight(date), inquiryId, version);
  };

  return (
    <SkeletonLoader
      id={`${id}__inquiry-loader-${inquiryId}`}
      isLoaded={inquiryId !== undefined}
    >
      <DateCell
        actionType={DateCellAction.CHANGE_DATE}
        date={toLocalMidnight(dateValue)}
        id={`${id}__inquiry-${inquiryId}`}
        onClick={handleChangeDate}
        shouldExcludePastDates
        shouldShowRelativeTime
      />
    </SkeletonLoader>
  );
};

export default InquiryTargetAdmissionDateCell;
